import {useMemo} from 'react'
import {WithTranslation, withTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'

import {ReactComponent as Close} from '../../../assets/icons/close.svg'
import {PATHS} from '../../../constants/paths'
import {useWallet} from '../../../contexts/WalletContext'
import {useCustomerSlice} from '../../../store/slices/customer'

import styles from './Menu.module.scss'

interface IMenuOption {
  translationKey: string
  action: () => void
  disabled?: boolean
}

interface IMenuProps extends WithTranslation {
  onChooseAction: () => void
}
const Menu = ({t, onChooseAction}: IMenuProps) => {
  const {disconnectWallet} = useWallet()
  const navigate = useNavigate()
  const {
    customer_info: {group},
  } = useCustomerSlice()
  const menuOptions: IMenuOption[] = useMemo(
    () => [
      {
        translationKey: 'panel',
        action: () => {
          onChooseAction()
          navigate(PATHS.PANEL)
        },
        disabled: !!group && group !== 'project-admin',
      },
      {
        translationKey: 'myWallet',
        action: () => {
          onChooseAction()
          navigate(PATHS.PORTFOLIO)
        },
      },
      {
        translationKey: 'profile',
        action: () => {
          onChooseAction()
          navigate(PATHS.PROFILE)
        },
      },
      {
        translationKey: 'recentTransactions',
        action: () => {
          onChooseAction()
          navigate(PATHS.RECENT_TRANSACTIONS)
        },
      },
      {
        translationKey: 'help',
        action: () => {
          window.open('https://help.horizontetoken.com', '_blank')
        },
      },
      {
        translationKey: 'singOff',
        action: () => {
          disconnectWallet()
          onChooseAction()
        },
      },
    ],
    [t],
  )

  return (
    <div className={styles.menu}>
      <Close className={styles.close} onClick={onChooseAction} />
      {menuOptions.map(
        option =>
          !option.disabled && (
            <div key={option.translationKey} className={styles.option} onClick={option.action}>
              {t(`header.menu.${option.translationKey}`)}
            </div>
          ),
      )}
    </div>
  )
}

export default withTranslation()(Menu)
